var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7515 6.69999C11.6619 6.44646 11.496 6.22695 11.2764 6.07168C11.0569 5.91641 10.7946 5.83303 10.5258 5.83303C10.2569 5.83303 9.9946 5.91641 9.77507 6.07168C9.55555 6.22695 9.38957 6.44646 9.3 6.69999",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70005 6.69999C6.61048 6.44646 6.4445 6.22695 6.22497 6.07168C6.00545 5.91641 5.74318 5.83303 5.47429 5.83303C5.20541 5.83303 4.94314 5.91641 4.72361 6.07168C4.50408 6.22695 4.3381 6.44646 4.24854 6.69999",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 10.6C10.1667 10.8873 10.0525 11.1629 9.84937 11.366C9.6462 11.5692 9.37065 11.6833 9.08333 11.6833C8.79602 11.6833 8.52047 11.5692 8.3173 11.366C8.11414 11.1629 8 10.8873 8 10.6C8 10.8873 7.88586 11.1629 7.6827 11.366C7.47954 11.5692 7.20398 11.6833 6.91667 11.6833C6.62935 11.6833 6.3538 11.5692 6.15063 11.366C5.94747 11.1629 5.83333 10.8873 5.83333 10.6",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7515 6.69999C11.6619 6.44646 11.496 6.22695 11.2764 6.07168C11.0569 5.91641 10.7946 5.83303 10.5258 5.83303C10.2569 5.83303 9.9946 5.91641 9.77507 6.07168C9.55555 6.22695 9.38957 6.44646 9.3 6.69999M6.70005 6.69999C6.61048 6.44646 6.4445 6.22695 6.22497 6.07168C6.00545 5.91641 5.74318 5.83303 5.47429 5.83303C5.20541 5.83303 4.94314 5.91641 4.72361 6.07168C4.50408 6.22695 4.3381 6.44646 4.24854 6.69999M10.1667 10.6C10.1667 10.8873 10.0525 11.1629 9.84937 11.366C9.6462 11.5692 9.37065 11.6833 9.08333 11.6833C8.79602 11.6833 8.52047 11.5692 8.3173 11.366C8.11414 11.1629 8 10.8873 8 10.6C8 10.8873 7.88586 11.1629 7.6827 11.366C7.47954 11.5692 7.20398 11.6833 6.91667 11.6833C6.62935 11.6833 6.3538 11.5692 6.15063 11.366C5.94747 11.1629 5.83333 10.8873 5.83333 10.6M14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8Z",
    stroke: "#589F23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGood);
export default __webpack_public_path__ + "static/media/flag-good.201c48f807667cf9211d431a763e49d3.svg";
export { ForwardRef as ReactComponent };